// Temporarily disabled support bot embed to avoid injecting the iframe/chat
const SupportBotEmbed = () => null;

export default SupportBotEmbed;
